import { FC, useState } from "react";
import Input from "@components/ui/input";
import cn from "classnames";
import { useForm } from "react-hook-form";
import { Alert, Content, FilterButton, HideButton, Pagination } from "./components";
import { Form, FormButton } from "./components/form";
import { TableHeader, TableInput, TableItems, TableRow } from "./components/table";
import styles from "./Scam.module.scss";

const Scam: FC = () => {
    const { register, handleSubmit, formState } = useForm();
    const [currentPage, setCurrentPage] = useState(1);
    const [isFormVisible, setIsFormVisible] = useState(true);

    return (
        <Content>
            <HideButton isVisible={isFormVisible} setIsVisible={setIsFormVisible} />
            <div className={cn(styles.leftHolder, { [styles.hidden]: !isFormVisible })}>
                <Form formState={formState} register={register} onSubmit={handleSubmit((data) => console.log(data))}>
                    <FormButton />
                </Form>
                <Alert />
            </div>
            <div className={cn(styles.block, styles.projects)}>
                <div className={styles.blockContent}>
                    <TableHeader>
                        <FilterButton />
                        <TableInput>
                            <Input name="search" classNames={styles.search} required placeholder="Search" type="text" />
                        </TableInput>
                    </TableHeader>
                    <TableItems>
                        <TableRow
                            date="01.01.1970"
                            link="/"
                            name="TON"
                            status="Review"
                            walletNumber="E2f32dwW3ujR734"
                        />
                        <TableRow
                            date="01.01.1970"
                            link="/"
                            name="TON"
                            status="Suspiciously"
                            walletNumber="E2f32dwW3ujR734"
                        />
                        <TableRow
                            date="01.01.1970"
                            link="/"
                            name="TON"
                            status="Verified"
                            walletNumber="E2f32dwW3ujR734"
                        />
                        <TableRow
                            date="01.01.1970"
                            link="/"
                            name="TON"
                            status="Suspiciously"
                            walletNumber="E2f32dwW3ujR734"
                        />
                        <TableRow
                            date="01.01.1970"
                            link="/"
                            name="TON"
                            status="Review"
                            walletNumber="E2f32dwW3ujR734"
                        />
                        <TableRow date="01.01.1970" link="/" name="TON" status="SCAM" walletNumber="E2f32dwW3ujR734" />
                        <TableRow
                            date="01.01.1970"
                            link="/"
                            name="TON"
                            status="Verified"
                            walletNumber="E2f32dwW3ujR734"
                        />
                    </TableItems>
                </div>
                <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
            </div>
        </Content>
    );
};

export default Scam;
